import { render, staticRenderFns } from "./SelectablePlayer.vue?vue&type=template&id=161a2061&"
import script from "./SelectablePlayer.vue?vue&type=script&lang=js&"
export * from "./SelectablePlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports